import { Grid } from "@mui/material";
import { DateTimeInput } from "components/FormControls/DateTimeInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { alphabetizeByProperty } from "utilities/arrays";
import { internalEventsList } from "../../Common/CampaignTriggers/InternalEvent/helpers";

export function InternalEventCampaignSimulation() {
  const { message } = useMessage();

  return (
    <Grid container spacing={10}>
      <Grid xs={6} item>
        <SelectInput
          displaySearch
          name="internal_event.type"
          data-test-id="campaign-simulator-internal-event-type-select"
          items={
            alphabetizeByProperty(
              internalEventsList.map((element) => {
                return {
                  id: element.event,
                  label: message({
                    id: element.name,
                  }),
                };
              }),
              "name",
            ) || []
          }
          label={<RequiredFieldLabel text={message({ id: "eventType" })} />}
        />
      </Grid>
      <Grid xs={6} item>
        <DateTimeInput
          width="100%"
          defaultValue={null}
          format="yyyy-MM-dd HH:mmXXX"
          label={<RequiredFieldLabel text={message({ id: "eventDate" })} />}
          name="internal_event.eventDate"
          data-test-id="campaign-simulator"
        />
      </Grid>
    </Grid>
  );
}
